// Is an optional dependency
// eslint-disable-next-line @backstage/no-undeclared-imports
import { faker } from '@faker-js/faker'
import {
  TasksListResponse,
  PolicyRuleSeverity,
} from '../client/ria-multi-agent-system.schemas'

const severities = Object.values(PolicyRuleSeverity)
const MOCK_TARGET_USER_EMAIL = 'fasf@fasdf.com'

export const tasksListResponseMock: TasksListResponse = {
  total: 10,
  tasks: [
    {
      id: 'task-001',
      agent_name: 'ria_agent',
      task_type: 'entra_assign_groups',
      description: 'Sync employee records from SAP to Entra',
      approval_status: 'pending_approval',
      approval_required: true,
      remediated_at: faker.date.past().toISOString(),
      remediated_by: faker.person.fullName(),
      completed_at: faker.date.past().toISOString(),
      error: null,
      rule_id: faker.lorem.word(),
      rule_category: faker.lorem.word(),
      rule_severity: faker.helpers.arrayElement(severities),
      source_policy: faker.lorem.word(),
      created_at: '2025-11-19T08:00:00Z',
      escalation_date: '2025-11-20T10:00:00Z',
      assignee_email: 'fasf',
      assignee_role: 'fasfa',
      escalation_email: 'sfasf',
      escalation_role: 'asfasf',
      execution_status: 'pending',
      source_type: 'manual',
      result: {
        user_id: 'abc',
        user_email: '123',
        user_name: '12312',
        disabled_at: faker.date.past().toISOString(),
        success: true,
      },
      target_user_email: MOCK_TARGET_USER_EMAIL,
    },
    {
      id: 'task-002',
      agent_name: 'hr_agent',
      task_type: 'entra_create_account',
      description: 'Generate monthly workforce analytics report',
      approval_status: 'approved',
      approval_required: true,
      remediated_at: faker.date.past().toISOString(),
      remediated_by: faker.person.fullName(),
      completed_at: faker.date.past().toISOString(),
      error: null,
      rule_id: faker.lorem.word(),
      rule_category: faker.lorem.word(),
      rule_severity: faker.helpers.arrayElement(severities),
      source_policy: faker.lorem.word(),
      created_at: '2025-11-19T07:30:00Z',
      escalation_date: '2025-11-21T10:00:00Z',
      assignee_email: 'fasf',
      assignee_role: 'fasfa',
      escalation_email: 'sfasf',
      escalation_role: 'asfasf',
      execution_status: 'completed',
      source_type: 'sf_poll',
      target_user_email: MOCK_TARGET_USER_EMAIL,
      result: null,
    },
    {
      id: 'task-003',
      agent_name: 'ria_agent',
      task_type: 'entra_disable_account',
      description: 'Remove duplicate employee entries',
      approval_status: 'pending_approval',
      approval_required: true,
      remediated_at: faker.date.past().toISOString(),
      remediated_by: faker.person.fullName(),
      completed_at: faker.date.past().toISOString(),
      error: null,
      rule_id: faker.lorem.word(),
      rule_category: faker.lorem.word(),
      rule_severity: faker.helpers.arrayElement(severities),
      source_policy: faker.lorem.word(),
      created_at: '2025-11-19T09:00:00Z',
      escalation_date: '2025-11-19T22:00:00Z',
      assignee_email: 'fasf',
      assignee_role: 'fasfa',
      escalation_email: 'sfasf',
      escalation_role: 'asfasf',
      execution_status: 'failed',
      source_type: 'sf_upload',
      target_user_email: MOCK_TARGET_USER_EMAIL,
      result: null,
    },
    {
      id: 'task-004',
      agent_name: 'topdesk_agent',
      task_type: 'entra_remove_groups',
      description: 'Review and update user access permissions',
      approval_status: 'rejected',
      approval_required: true,
      remediated_at: faker.date.past().toISOString(),
      remediated_by: faker.person.fullName(),
      completed_at: faker.date.past().toISOString(),
      error: null,
      rule_id: faker.lorem.word(),
      rule_category: faker.lorem.word(),
      rule_severity: faker.helpers.arrayElement(severities),
      source_policy: faker.lorem.word(),
      created_at: '2025-11-19T06:00:00Z',
      escalation_date: '2025-11-26T10:00:00Z',
      assignee_email: 'fasf',
      assignee_role: 'fasfa',
      escalation_email: 'sfasf',
      escalation_role: 'asfasf',
      execution_status: 'pending',
      source_type: 'manual',
      target_user_email: MOCK_TARGET_USER_EMAIL,
      result: null,
    },
    {
      id: 'task-005',
      agent_name: 'ria_agent',
      task_type: 'entra_update_groups',
      description: 'Apply new compliance policies to active employees',
      approval_status: 'approved',
      approval_required: true,
      remediated_at: faker.date.past().toISOString(),
      remediated_by: faker.person.fullName(),
      completed_at: faker.date.past().toISOString(),
      error: null,
      rule_id: faker.lorem.word(),
      rule_category: faker.lorem.word(),
      rule_severity: faker.helpers.arrayElement(severities),
      source_policy: faker.lorem.word(),
      created_at: '2025-11-19T09:30:00Z',
      escalation_date: '2025-11-22T10:00:00Z',
      assignee_email: 'fasf',
      assignee_role: 'fasfa',
      escalation_email: 'sfasf',
      escalation_role: 'asfasf',
      execution_status: 'pending',
      source_type: 'manual',
      target_user_email: MOCK_TARGET_USER_EMAIL,
      result: null,
    },
    {
      id: 'task-006',
      agent_name: 'ria_agent',
      task_type: 'entra_update_groups',
      description: 'Create IT tickets for 12 onboarding requests',
      approval_status: 'pending_approval',
      approval_required: true,
      remediated_at: faker.date.past().toISOString(),
      remediated_by: faker.person.fullName(),
      completed_at: faker.date.past().toISOString(),
      error: null,
      rule_id: faker.lorem.word(),
      rule_category: faker.lorem.word(),
      rule_severity: faker.helpers.arrayElement(severities),
      source_policy: faker.lorem.word(),
      created_at: '2025-11-19T06:00:00Z',
      escalation_date: '2025-11-25T10:00:00Z',
      assignee_email: 'fasf',
      assignee_role: 'fasfa',
      escalation_email: 'sfasf',
      escalation_role: 'asfasf',
      execution_status: 'pending',
      source_type: 'manual',
      target_user_email: MOCK_TARGET_USER_EMAIL,
      result: null,
    },
    {
      id: 'task-007',
      agent_name: 'policy_agent',
      task_type: 'sap_disable_account',
      description: 'Validate payroll data for upcoming cycle',
      approval_status: 'approved',
      approval_required: true,
      remediated_at: faker.date.past().toISOString(),
      remediated_by: faker.person.fullName(),
      completed_at: faker.date.past().toISOString(),
      error: null,
      rule_id: faker.lorem.word(),
      rule_category: faker.lorem.word(),
      rule_severity: faker.helpers.arrayElement(severities),
      source_policy: faker.lorem.word(),
      created_at: '2025-11-19T07:00:00Z',
      escalation_date: '2025-11-23T10:00:00Z',
      assignee_email: 'fasf',
      assignee_role: 'fasfa',
      escalation_email: 'sfasf',
      escalation_role: 'asfasf',
      execution_status: 'pending',
      source_type: 'manual',
      target_user_email: MOCK_TARGET_USER_EMAIL,
      result: null,
    },
    {
      id: 'task-008',
      agent_name: 'ria_agent',
      task_type: 'entra_assign_groups',
      description: 'Escalate critical alerts to management',
      approval_status: 'rejected',
      approval_required: true,
      remediated_at: faker.date.past().toISOString(),
      remediated_by: faker.person.fullName(),
      completed_at: faker.date.past().toISOString(),
      error: null,
      rule_id: faker.lorem.word(),
      rule_category: faker.lorem.word(),
      rule_severity: faker.helpers.arrayElement(severities),
      source_policy: faker.lorem.word(),
      created_at: '2025-11-19T08:45:00Z',
      escalation_date: '2025-11-19T16:00:00Z',
      assignee_email: 'fasf',
      assignee_role: 'fasfa',
      escalation_email: 'sfasf',
      escalation_role: 'asfasf',
      execution_status: 'pending',
      source_type: 'manual',
      target_user_email: MOCK_TARGET_USER_EMAIL,
      result: null,
    },
    {
      id: 'task-009',
      agent_name: 'ria_agent',
      task_type: 'entra_disable_account',
      description: 'Import SuccessFactors performance reviews',
      approval_status: 'approved',
      approval_required: true,
      remediated_at: faker.date.past().toISOString(),
      remediated_by: faker.person.fullName(),
      completed_at: faker.date.past().toISOString(),
      error: null,
      rule_id: faker.lorem.word(),
      rule_category: faker.lorem.word(),
      rule_severity: faker.helpers.arrayElement(severities),
      source_policy: faker.lorem.word(),
      created_at: '2025-11-19T09:15:00Z',
      escalation_date: '2025-11-24T10:00:00Z',
      assignee_email: 'fasf',
      assignee_role: 'fasfa',
      escalation_email: 'sfasf',
      escalation_role: 'asfasf',
      execution_status: 'pending',
      source_type: 'manual',
      target_user_email: MOCK_TARGET_USER_EMAIL,
      result: null,
    },
    {
      id: 'task-010',
      agent_name: 'ria_agent',
      task_type: 'entra_remove_groups',
      description: 'Run compliance audit on all active accounts',
      approval_status: 'approved',
      approval_required: true,
      remediated_at: faker.date.past().toISOString(),
      remediated_by: faker.person.fullName(),
      completed_at: faker.date.past().toISOString(),
      error: null,
      rule_id: faker.lorem.word(),
      rule_category: faker.lorem.word(),
      rule_severity: faker.helpers.arrayElement(severities),
      source_policy: faker.lorem.word(),
      created_at: '2025-11-19T08:15:00Z',
      escalation_date: '2025-12-03T10:00:00Z',
      assignee_email: 'fasf',
      assignee_role: 'fasfa',
      escalation_email: 'sfasf',
      escalation_role: 'asfasf',
      execution_status: 'pending',
      source_type: 'manual',
      target_user_email: MOCK_TARGET_USER_EMAIL,
      result: null,
    },
  ],
}
